var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.048 33.952c-1.49-1.168-2.23-2.38-2.227-3.636a4.343 4.343 0 0 1 1.187-3.11l16.9-16.849c1.164.99 1.852 2.113 2.075 3.38a3.79 3.79 0 0 1-1.078 3.41L14.048 33.952zm-6.022-6.004c-1.495-1.172-2.235-2.384-2.227-3.636a4.343 4.343 0 0 1 1.185-3.11l16.9-16.85c1.16.987 1.851 2.113 2.074 3.38a3.79 3.79 0 0 1-1.083 3.407L8.026 27.946zM1.999 21.94C.504 20.767-.236 19.556-.228 18.303a4.343 4.343 0 0 1 1.185-3.11l16.9-16.848c1.164.99 1.852 2.112 2.075 3.38a3.79 3.79 0 0 1-1.078 3.41L1.999 21.94z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLina);
export default __webpack_public_path__ + "static/media/LINA.aa3653cfb840b0d8578b38fcd9ec4d4c.svg";
export { ForwardRef as ReactComponent };